<template>
  <div class="delete-incomplete-archives-dialog-box">
    <el-dialog
      :title="$t('wr-dashboard.delete-all-incomplete-archives-dialog-box.title')"
      @close="onClose"
      visible
    >
      <div
        class="el-text el-text--body-24 mx-24 my-16"
        v-if="!isArchiveLocked">
        {{ $t('wr-dashboard.delete-archive.message') }}
      </div>

      <el-alert
        type="warning"
        :description="$t('wr-dashboard.delete-archive.locked-error-message')"
        show-icon
        hide-close
        v-if="isArchiveLocked"
      />

      <template slot="footer">
        <el-button
          @click="onClose"
          native-type="button"
          type="secondary"
        >
          {{ $t('wr-dashboard.form.button.cancel') }}
        </el-button>
        <el-button
          native-type="button"
          @click="onDelete"
          type="danger"
          :loading="isInProgress"
          :disabled="isInProgress"
        >
          {{ $t('wr-dashboard.form.button.delete') }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  PENDING_STATUS,
  COMPLETED_STATUS, LOCKED_STATUS
} from '../store/action-status';

import {
  DELETE_ALL_INCOMPLETE_BACKUPS,
  RESET_DELETE_ALL_INCOMPLETE_STATUS_STATUS
} from '../store/action-types';

const { mapGetters, mapActions } = createNamespacedHelpers('wr-dashboard');

export default {
  name: 'DeleteIncompleteArchivesDialogBox',
  data() {
    return {
      isArchiveLocked: false
    };
  },
  computed: {
    ...mapGetters([
      'getDeleteAllIncompleteStatus',
      'getTotalUsedSpace',
      'getIncompleteBackupsSize'
    ]),
    isInProgress() {
      return this.getDeleteAllIncompleteStatus === PENDING_STATUS;
    }
  },
  watch: {
    getDeleteAllIncompleteStatus(status) {
      if (status === COMPLETED_STATUS) {
        this.onClose();
      } else if (status === PENDING_STATUS) {
        this.isArchiveLocked = false;
      } else if (status === LOCKED_STATUS) {
        this.isArchiveLocked = true;
      }
    }
  },
  methods: {
    ...mapActions({
      deleteAllIncomplete: DELETE_ALL_INCOMPLETE_BACKUPS,
      resetArchiveDeletionStatus: RESET_DELETE_ALL_INCOMPLETE_STATUS_STATUS
    }),
    onDelete() {
      this.deleteAllIncomplete({
        totalUsedSpace: this.getTotalUsedSpace,
        incompleteBackupsSize: this.getIncompleteBackupsSize
      });
    },
    onClose() {
      this.$emit('handleClose');
    }
  },
  mounted() {
    this.isArchiveLocked = false;
    this.resetArchiveDeletionStatus();
  }
};
</script>

<style lang="scss" scoped>

</style>
